import { useMutation } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import type {
  OverlapAnalysisResult,
  OverlapAnalyzeRequest,
  OverlapRequest,
  OverlapResponse,
} from "@/types/overlap";

export function useComputeOverlap() {
  return useMutation<OverlapResponse, Error, OverlapRequest>({
    mutationFn: (data) =>
      apiClient
        .post("api/concepts/overlap", { json: data })
        .json<OverlapResponse>(),
  });
}

export function useAnalyzeOverlap() {
  return useMutation<OverlapAnalysisResult, Error, OverlapAnalyzeRequest>({
    mutationFn: (data) =>
      apiClient
        .post("api/concepts/overlap/analyze", {
          json: data,
          timeout: 120_000,
        })
        .json<OverlapAnalysisResult>(),
  });
}
